import { Component, OnInit, OnDestroy, AfterViewInit, HostListener, Input, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeContext, Options } from 'ng5-slider';

import { LogService } from './../shared';
import { Carrier, Port, Trip } from './../shared/models';
import { Trips } from './../shared/models/trip-models/trips';
import { SchedulesService } from './schedules.service';

declare const moment: any;

@Component({
  selector: 'schedules',
  template: require('./schedules.component.html'),
  styles: [require('./schedules.component.scss')],
  providers: [SchedulesService]
})
export class SchedulesComponent implements OnInit, OnDestroy, AfterViewInit {
  schedules: Trips;

  originPorts = new Array<any>();
  showAllOriginPorts: boolean = false;
  destinationPorts = new Array<any>();
  showAllDestinationPorts: boolean = false;
  portShowLimit: number = 10;

  originId: string = '';
  destinationId: string = '';

  departureSet: boolean = false;
  departureRange: string = 'any';
  departureDateGreater: string;
  departureDateLess: string;

  destinationSearch: string = '';
  originSearch: string = '';

  destinationType: string = 'port';
  originType: string = 'port';

  arrivalSet: boolean = false;
  arrivalRange: string = 'any';
  arrivalDateGreater: string;
  arrivalDateLess: string;

  nearbyOriginPorts: boolean = false;
  nearbyDestinationPorts: boolean = false;

  sort: string = 'duration';
  offset: number = 0;
  limit: number = 25;
  minDuration: number = 0;
  maxDuration: number = 0;
  sub: any;

  pages: Array<number> = [];
  pageNumber: number = 1;
  paginationContext: string = '';
  resultsNumber: string = '';
  showShare: boolean = false;
  showSave: boolean = false;
  showContact: boolean = false;
  contactSchedule: any;

  showTransSales: boolean = false;
  displayType: string = 'trips';
  mapsHiddenVar = false;
  
  showRoutes: boolean = false;

  constructor(private logger: LogService, private service: SchedulesService, private route: ActivatedRoute, private router: Router, private zone: NgZone) {
    // Do stuff
  }

  ngOnInit() {
    this.logger.log('schedules.component', 'ngOnInit params', this.route.snapshot.params);
    this.schedules = new Trips(null);

    this.sub = this.route.params.subscribe(params => {
      if (params['search_id'] != null) {
        this.setupSharedSearch(params['search_id']);
      } else {
        this.setupPage(params);
      }
    });
    if (localStorage.getItem('mapsHidden') === 'true') {
      this.mapsHiddenVar = true;
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  @HostListener('window:resize', ['$event.target'])
  onResize() {
    this.service.resizeSidebar();
  }

  ngAfterViewInit() {
    this.service.resizeSidebar();
  }

  setupSharedSearch(searchId: string) {
    this.service.getParametersFromSearchId(searchId).then(result => {
      this.searchIdUpdate(result);
    }).catch(err => {
      this.logger.log('schedules.component', 'setupSharedSearch catch', err);
    });
  }

  // must use != null as !== null does not work for route parameter checks

  setupPage(params: { [key: string]: any }): void {
    this.schedules = new Trips(null);

    this.setupOrigin(params);
    this.setupDestination(params);
    this.setupFilters(params);
    this.setupDates(params);

    // if (params['limit'] != null || params['offset'] != null) {
    //   let old = JSON.parse(localStorage.getItem('saved-schedules' + this.originId + this.destinationId));
    //   if (old !== null && old !== undefined) {
    //     old.items = [];
    //     this.schedules = old;
    //     this.service.resizeSidebar();
    //   }
    // }

    if ((this.originType === 'port' || this.originType === 'share') && (this.destinationType === 'port' || this.destinationType === 'share')) {
      this.getSchedules();
    }
  }

  setupOrigin(params) {
    if (params['selected_origin_ids'] != null) {
      this.schedules.selectedOriginPorts = params['selected_origin_ids'].split(',').map(Number);
    } else {
      this.schedules.selectedOriginPorts = [];
    }

    if (params['origin_search'] != null) {
      this.originSearch = params['origin_search'];
    } else {
      this.originSearch = 'Origin';
    }

    // origin id will always be a single id (be it port or region/country)
    if (params['origin_id'] != null) {
      this.originId = params['origin_id'];
    }

    if (params['origin_type'] != null) {
      this.originType = params['origin_type'];
    }

    if (params['with_nearby_origins'] === 'true') {
      // this.nearbyOriginPorts = Boolean(params['with_nearby_origins']);
      if(this.service.app.accountType === '' || this.service.app.accountType === 'Basic') {
        this.nearbyOriginPorts = false;}
      // } else if (this is for boxes that are unchecked by pro or prem user)
      else {
        this.nearbyOriginPorts = true;
      }
    }

    if (this.originType === 'share') {
      // shared search with multiple ports
    } else if (this.originType !== 'port') {
      this.service.getPortsForLocation(this.originType, this.originId).then((ports: any) => {
        this.logger.log('schedules.component', 'setupOrigin ports', ports);
        this.originPorts = ports;

        let selectAll = this.schedules.selectedOriginPorts.length === 0;
        for (let current = 0; current < this.originPorts.length; current++) {
          let origin = this.originPorts[current];
          origin.selected = selectAll || (this.schedules.selectedOriginPorts.indexOf(origin.port.id) > -1);

          if (selectAll) {
            this.schedules.selectedOriginPorts.push(origin.port.id);
          }
        }

        if (this.destinationPorts.length !== 0 || this.destinationType === 'port') {
          // single port information is returned by the schedule call for speed
          this.getSchedules();
        }
      }).catch(err => {
        this.originPorts = [];
        // ask user to re-search
      });
    } else {
      this.schedules.selectedOriginPorts = [+this.originId];
    }
  }

  setupDestination(params) {
    if (params['selected_destination_ids'] != null) {
      this.schedules.selectedDestinationPorts = params['selected_destination_ids'].split(',').map(Number);
    } else {
      this.schedules.selectedDestinationPorts = [];
    }

    if (params['destination_search'] != null) {
      this.destinationSearch = params['destination_search'];
    } else {
      this.destinationSearch = 'Destination';
    }

    // destination id will always be a single id (be it port or region/country)
    if (params['destination_id'] != null) {
      this.destinationId = params['destination_id'];
    }

    if (params['destination_type'] != null) {
      this.destinationType = params['destination_type'];
    }

    if (params['with_nearby_destinations'] === 'true') {
      // this.nearbyDestinationPorts = Boolean(params['with_nearby_destinations']);
      if(this.service.app.accountType === '' || this.service.app.accountType === 'Basic') {
        this.nearbyDestinationPorts = false;}
      // } else if (this is for boxes that are unchecked by pro or prem user)
      else {
        this.nearbyDestinationPorts = true;
      }
    }

    if (this.destinationType === 'share') {
      // shared search with multiple ports
    } else if (this.destinationType !== 'port') {
      this.service.getPortsForLocation(this.destinationType, this.destinationId).then((ports: any) => {
        this.logger.log('schedules.component', 'setupDestination ports', ports);
        this.destinationPorts = ports;

        let selectAll = this.schedules.selectedDestinationPorts.length === 0;
        for (let current = 0; current < this.destinationPorts.length; current++) {
          let destination = this.destinationPorts[current];
          destination.selected = selectAll || (this.schedules.selectedDestinationPorts.indexOf(destination.port.id) > -1);

          if (selectAll) {
            this.schedules.selectedDestinationPorts.push(destination.port.id);
          }
        }

        if (this.originPorts.length !== 0 || this.originType === 'port') {
          // single port information is returned by the schedule call for speed
          this.getSchedules();
        }
      }).catch(err => {
        this.destinationPorts = [];
        // ask user to re-search
      });
    } else {
      this.schedules.selectedDestinationPorts = [+this.destinationId];
    }
  }

  setupFilters(params) {
    if (params['carriers'] != null) {
      this.schedules.selectedCarriers = params['carriers'].split(',').map(Number);
    } else {
      this.schedules.selectedCarriers = [];
    }

    if (params['excluded_carriers'] != null) {
      this.schedules.excludedCarriers = params['excluded_carriers'].split(',').map(Number);
    } else {
      this.schedules.excludedCarriers = [];
    }

    if (params['transhipment_counts'] != null) {
      this.schedules.selectedTranshipments = params['transhipment_counts'].split(',').map(Number);
    }

    if (params['scroll'] != null && params['scroll'] == 'true') {
      window.scrollTo(0, 0);
    }

    this.sort = params['sort'] || 'duration';
    this.limit = +params['limit'] || 25;
    this.offset = +params['offset'] || 0;
    this.minDuration = +params['duration_gte'] || 0;
    this.maxDuration = +params['duration_lte'] || 0;

  }

  setupDates(params) {
    if (moment(decodeURIComponent(params['start_date_gte'])).format('YYYY-MM-DD') != 'Invalid date') {
      this.departureSet = true;
      let gte = decodeURIComponent(params['start_date_gte']);
      let lte = decodeURIComponent(params['start_date_lte']);
      this.departureDateGreater = moment(gte).format('YYYY-MM-DD');
      this.departureDateLess = moment(lte).format('YYYY-MM-DD');
      this.departureRange = moment(this.departureDateGreater).format('YYYY-MM-DD') + ' to ' + moment(this.departureDateLess).format('YYYY-MM-DD');
    }

    if (moment(decodeURIComponent(params['end_date_gte'])).format('YYYY-MM-DD') != 'Invalid date') {
      this.arrivalSet = true;
      let gte = decodeURIComponent(params['end_date_gte']);
      let lte = decodeURIComponent(params['end_date_lte']);
      this.arrivalDateGreater = moment(gte).format('YYYY-MM-DD');
      this.arrivalDateLess = moment(lte).format('YYYY-MM-DD');
      this.arrivalRange = moment(this.arrivalDateGreater).format('YYYY-MM-DD') + ' to ' + moment(this.arrivalDateLess).format('YYYY-MM-DD');
    }
  }

  setupPagination() {
    this.pageNumber = Math.floor(this.offset / this.limit) + 1;
    let pageTotal = Math.ceil(this.schedules.total / this.limit);
    let newPages = [];

    if (this.pages === null) {
      this.pages = [];
    }
    else if (pageTotal <= 9) {
      let count = 0;
      for (let current = 1; current <= pageTotal; current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    } else if (this.pageNumber <= 5) {
      this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    } else if ((this.pageNumber > 5) && (this.pageNumber > pageTotal - 4)) {
      let count = 0;
      for (let current = pageTotal - 9; current <= pageTotal; current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    } else {
      let count = 0;
      for (let current = this.pageNumber - 5; (current < this.pageNumber + 4) && (current < pageTotal); current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    }

    if (this.pageNumber === pageTotal) {
      this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.schedules.total) + ' of ' + this.schedules.total;
    } else {
      this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.limit * this.pageNumber) + ' of ' + this.schedules.total;
    }
    this.resultsNumber = this.schedules.total.toString();
  }

  toPage(page: number) {
    if (page == this.pageNumber){
      // dont call update
      return;
    }

    this.offset = (page - 1) * this.limit;
    
    this.hideMaps();
    this.update();
  }

  changeDisplay(type: string) {
    this.displayType = type;
  }

  selectCarrier(carrier: Carrier) {
    if (this.schedules.selectedCarriers.length === 1 && carrier.id === this.schedules.selectedCarriers[0]) {
      return;
    }

    carrier.selected = !carrier.selected;
    let excludedIndex = this.schedules.excludedCarriers.indexOf(carrier.id);
    let selectedIndex = this.schedules.selectedCarriers.indexOf(carrier.id);

    if (carrier.selected) {
      // select
      if (excludedIndex > -1) {
        this.schedules.excludedCarriers.splice(excludedIndex, 1);
      }

      if (this.schedules.selectedCarriers.length !== 0) {
        if (selectedIndex === -1) {
          this.schedules.selectedCarriers.push(carrier.id);
        }
      }
    } else {
      // de-select
      if (excludedIndex === -1) {
        this.schedules.excludedCarriers.push(carrier.id);
      }

      if (this.schedules.selectedCarriers.length !== 0) {
        if (selectedIndex > -1) {
          this.schedules.selectedCarriers.splice(selectedIndex, 1);
        }
      }
    }

    this.hideMaps();
    this.update();
  }

  selectDestinationPort(destination: { count: number, selected: boolean, port: Port }) {
    if (this.schedules.selectedDestinationPorts.length === 1 && destination.port.id === this.schedules.selectedDestinationPorts[0]) {
      return;
    }

    destination.selected = !destination.selected;
    let index = this.schedules.selectedDestinationPorts.indexOf(destination.port.id);
    if (index > -1) {
      this.schedules.selectedDestinationPorts.splice(index, 1);
      destination.port.iconUrl = '../img/port-unselected.png';
    }
    else {
      this.schedules.selectedDestinationPorts.push(destination.port.id);
      destination.port.iconUrl = '../img/port-selected.png';
    }

    // this.update();
    this.getSchedules();
  }

  selectOriginPort(origin: { count: number, selected: boolean, port: Port }) {
    if (this.schedules.selectedOriginPorts.length === 1 && origin.port.id === this.schedules.selectedOriginPorts[0]) {
      return;
    }

    origin.selected = !origin.selected;
    let index = this.schedules.selectedOriginPorts.indexOf(origin.port.id);
    if (index > -1) {
      this.schedules.selectedOriginPorts.splice(index, 1);
      origin.port.iconUrl = '../img/port-unselected.png';
    } else {
      this.schedules.selectedOriginPorts.push(origin.port.id);
      origin.port.iconUrl = '../img/port-selected.png';
    }

    // this.update();
    this.getSchedules();
  }

  deselectTransShipments() {
    if (this.schedules.transhipments.length > 1) {
      this.showTransSales = true;
    }
  }

  selectTranshipment(transhipment: any, only: boolean = false) {
    if (this.schedules.selectedTranshipments.length === 1 && transhipment.amount === this.schedules.selectedTranshipments[0]) {
      return; // do not let user de-select all transhipments
    }

    transhipment.selected = only ? true : !transhipment.selected;

    if (only) {
      this.schedules.selectedTranshipments = [transhipment.amount];
    } else {
      this.schedules.selectedTranshipments = [];

      for (let index = 0; index < this.schedules.transhipments.length; index++) {
        let transhipment = this.schedules.transhipments[index];
        if (transhipment.selected) {
          this.schedules.selectedTranshipments.push(transhipment.amount);
        }
      }
    }

    this.hideMaps();
    this.update();
  }

  portsAll() {
    this.schedules.selectedOriginPorts = [];
    this.schedules.selectedDestinationPorts = [];

    for (let current = 0; current < this.originPorts.length; current++) {
      let origin = this.originPorts[current];

      origin.selected = true;
      this.schedules.selectedOriginPorts.push(origin.port.id);
    }

    for (let current = 0; current < this.destinationPorts.length; current++) {
      let destination = this.destinationPorts[current];

      destination.selected = true;
      this.schedules.selectedDestinationPorts.push(destination.port.id);
    }

    this.hideMaps();
    this.update();
  }

  carriersAll() {
    this.schedules.selectedCarriers = [];
    this.schedules.excludedCarriers = [];

    for (let current = 0; current < this.schedules.carriers.length; current++) {
      this.schedules.carriers[current].selected = true;
    }

    this.hideMaps();
    this.update();
  }

  clearAll() {
    this.schedules.selectedCarriers = [];
    this.schedules.excludedCarriers = [];

    for (let current = 0; current < this.schedules.carriers.length; current++) {
      this.schedules.carriers[current].selected = false;
      this.schedules.excludedCarriers.push(this.schedules.carriers[current].id)
    }

    this.hideMaps();
    this.update();
  }

  allSelected() {
    var allSelected: Boolean = true;
    for (let current = 0; current < this.schedules.carriers.length; current++) {
      if (this.schedules.carriers[current].selected == false) {
        allSelected = false;
      }
    }
    return allSelected;
  }

  allCleared() {
    var allCleared: Boolean = true;
    for (let current = 0; current < this.schedules.carriers.length; current++) {
      if (this.schedules.carriers[current].selected == true) {
        allCleared = false;
      }
    }
    return allCleared;
  }


  portsFavorites() {
    if (this.service.app.ports.length === 0) {
      return;
    }

    try {
      let selectedOriginPorts = [];
      let selectedDestinationPorts = [];

      for (let current = 0; current < this.originPorts.length; current++) {
        let origin = this.originPorts[current];

        if (origin.port.userData.favorited) {
          selectedOriginPorts.push(origin.port.id);
          origin.selected = true;
        } else {
          origin.selected = false;
        }
      }

      for (let current = 0; current < this.destinationPorts.length; current++) {
        let destination = this.destinationPorts[current];

        if (destination.port.userData.favorited) {
          selectedDestinationPorts.push(destination.port.id);
          destination.selected = true;
        } else {
          destination.selected = false;
        }
      }

      this.schedules.selectedOriginPorts = selectedOriginPorts.length == 0 ? this.schedules.selectedOriginPorts : selectedOriginPorts;
      this.schedules.selectedDestinationPorts = selectedDestinationPorts.length == 0 ? this.schedules.selectedDestinationPorts : selectedDestinationPorts;

      this.hideMaps();
      this.update();
    } catch (ex) {
      // not logged in
    }
  }

  carriersFavorites() {
    if (this.service.app.carriers.length === 0) {
      return;
    }

    try {
      this.schedules.selectedCarriers = [];
      this.schedules.excludedCarriers = [];

      for (let current = 0; current < this.schedules.carriers.length; current++) {
        if (this.schedules.carriers[current].userData.favorited) {
          this.schedules.carriers[current].selected = true;
        }
      }
      for (let current = 0; current < this.service.app.carriers.length; current++) {
        this.schedules.selectedCarriers.push(this.service.app.carriers[current].id);
      }

      this.hideMaps();
      this.update();
    } catch (ex) {
      // not logged in
    }
  }

  rangeChange(target: ChangeContext) {
    this.logger.log('schedules.component', 'rangeChange startValue', +target.value);
    this.logger.log('schedules.component', 'rangeChange endValue', +target.highValue);
    this.minDuration = +target.value;
    this.maxDuration = +target.highValue;

    this.hideMaps();
    this.update();
  }

  update() {
    let params = {
      origin_id: this.originId,
      origin_type: this.originType,
      origin_search: this.originSearch.trim(),
      destination_id: this.destinationId,
      destination_type: this.destinationType,
      destination_search: this.destinationSearch.trim(),
      selected_origin_ids: this.schedules.selectedOriginPorts,
      selected_destination_ids: this.schedules.selectedDestinationPorts,
      sort: this.sort,
      limit: this.limit,
      offset: this.offset
    };

    this.setRouteFilterParams(params);
    this.setRouteDates(params);

    localStorage.setItem('saved-schedules' + this.originId + this.destinationId, JSON.stringify(this.schedules));
    this.router.navigate(['/schedules', params]);
  }

  setRouteDates(params) {
    if (this.departureSet) {
      if (moment(this.departureDateLess, 'YYYY-MM-DD').isBefore(this.departureDateGreater)) {
        params['start_date_gte'] = encodeURIComponent(this.departureDateLess);
        params['start_date_lte'] = encodeURIComponent(this.departureDateGreater);
      } else {
        params['start_date_gte'] = encodeURIComponent(this.departureDateGreater);
        params['start_date_lte'] = encodeURIComponent(this.departureDateLess);
      }
      // changing the date string creates an Angular exception because you change the value after it has checked the value
    }

    if (this.arrivalSet) {
      if (moment(this.arrivalDateLess, 'YYYY-MM-DD').isBefore(this.arrivalDateGreater)) {
        params['end_date_gte'] = encodeURIComponent(this.arrivalDateLess);
        params['end_date_lte'] = encodeURIComponent(this.arrivalDateGreater);
      } else {
        params['end_date_gte'] = encodeURIComponent(this.arrivalDateGreater);
        params['end_date_lte'] = encodeURIComponent(this.arrivalDateLess);
      }
      // changing the date string creates an Angular exception because you change the value after it has checked the value
    }

    if (this.minDuration !== 0 || this.maxDuration !== 0) {
      params['duration_gte'] = this.minDuration.toString();
      params['duration_lte'] = this.maxDuration.toString();
    }
  }

  searchIdUpdate(result) {
    let data = result.data.details;

    let params = {};
    this.setSavedPortParams(params, data);
    this.setSavedFilterParams(params, data);
    this.setSavedDateParams(params, data);

    this.router.navigate(['/schedules', params]);
  }

  setSavedPortParams(params: any, data: any) {
    if (data['origin_search'] != null) {
      params['origin_search'] = data['origin_search'];
    }

    if (data['origin_ids'] != null) {
      let origins = data['origin_ids'].split(',').map(Number);
      if (origins.length === 1) {
        //port
        params['origin_id'] = origins;
      } else {
        params['selected_origin_ids'] = origins;
        params['origin_type'] = 'share';
      }
    }

    if (data['destination_ids'] != null) {
      let destinations = data['destination_ids'].split(',').map(Number);
      if (destinations.length === 1) {
        params['destination_id'] = destinations;
      } else {
        params['selected_destination_ids'] = destinations;
        params['destination_type'] = 'share';
      }
    }

    if (data['destination_search'] != null) {
      params['destination_search'] = data['destination_search'];
    }
  }

  setSavedFilterParams(params: any, data: any) {
    params.sort = data.sort || 'duration';
    params.limit = +data.limit || 25;
    params.offset = +data.offset || 0;

    if (data['transhipment_counts'] != null) {
      params['transhipment_counts'] = data['transhipment_counts'];
    }

    if (data['carriers'] != null) {
      params['carriers'] = data['carriers'];
    }

    if (data['carriers.ne'] != null) {
      params['excluded_carriers'] = data['carriers.ne'];
    }
  }

  setSavedDateParams(params: any, data: any) {
    if (data['start_date.gte'] != null && data['start_date.lte'] != null) {
      params['start_date_gte'] = data['start_date.gte'];
      params['start_date_lte'] = data['start_date.lte'];
    }

    if (data['end_date.gte'] != null && data['end_date.lte'] != null) {
      params['end_date_gte'] = data['end_date.gte'];
      params['end_date_lte'] = data['end_date.lte'];
    }

    if (data['duration.gte'] != null) {
      params['duration_gte'] = data['duration.gte'];
    }

    if (data['duration.lte'] != null) {
      params['duration_lte'] = data['duration.lte'];
    }
  }

  getSchedules(retry = true) {
    let params = this.getParams();

    this.callGetSchedules(params, retry);
  }

  getParams(): any {
    let params = {
      origin_search: this.originSearch.trim(),
      origin_ids: this.schedules.selectedOriginPorts,
      destination_search: this.destinationSearch.trim(),
      destination_ids: this.schedules.selectedDestinationPorts,
      with_nearby_origins: +this.nearbyOriginPorts,
      with_nearby_destinations: +this.nearbyDestinationPorts,
      sort: this.sort,
      limit: this.limit,
      offset: this.offset,
    };
    this.setFilterParams(params);
    this.setDateParams(params);

    return params;
  }

  callGetSchedules(params: any, retry: boolean): void {
    this.logger.log('schedules.component', 'callGetSchedules params', params);
    if (params.destination_ids.length == 0 || params.origin_ids.length == 0) {
      this.formatSchedules(null);
      this.service.loaderOff = true;
      this.service.noResult = true;
    } else {
      this.service.getSchedules(params).then(schedules => {
        this.formatSchedules(schedules);
      }).catch(ex => {
        if (ex === 403 && retry) {
          this.getSchedules(false);
        }
      });
    }
  }

  setRouteFilterParams(params) {
    if (this.schedules.selectedTranshipments.length !== 0) {
      params['transhipment_counts'] = this.schedules.selectedTranshipments;
    }
    if (this.schedules.selectedCarriers.length !== 0) {
      params['carriers'] = this.schedules.selectedCarriers;
    }
    if (this.schedules.excludedCarriers.length !== 0) {
      params['excluded_carriers'] = this.schedules.excludedCarriers;
    }
  }

  setFilterParams(params) {
    if (this.schedules.selectedTranshipments.length !== 0) {
      params['transhipment_counts'] = this.schedules.selectedTranshipments;
    }
    if (this.schedules.selectedCarriers.length !== 0) {
      params['carriers'] = this.schedules.selectedCarriers;
    }
    if (this.schedules.excludedCarriers.length !== 0) {
      params['carriers.ne'] = this.schedules.excludedCarriers;
    }
  }

  setDateParams(params) {
    let start_gte = this.departureDateGreater !== undefined ? this.departureDateGreater : '';
    let start_lte = this.departureDateLess !== undefined ? this.departureDateLess : '';
    if (start_gte !== '') {
      params['start_date.gte'] = start_gte;
    }
    if (start_lte !== '') {
      params['start_date.lte'] = start_lte;
    }

    let end_gte = this.arrivalDateGreater !== undefined ? this.arrivalDateGreater : '';
    let end_lte = this.arrivalDateLess !== undefined ? this.arrivalDateLess : '';
    if (end_gte !== '') {
      params['end_date.gte'] = end_gte;
    }
    if (end_gte !== '') {
      params['end_date.lte'] = end_lte;
    }

    let duration_gte = this.minDuration === 0 ? '' : this.minDuration;
    let duration_lte = this.maxDuration === 0 ? '' : this.maxDuration;
    if (duration_gte !== '') {
      params['duration.gte'] = duration_gte;
    }
    if (duration_lte !== '') {
      params['duration.lte'] = duration_lte;
    }
  }

  formatSchedules(schedules: Trips) {
    this.logger.log('schedules.component', 'formatSchedules', schedules);
    if (schedules !== null) {
      this.schedules = schedules;

      this.formatOrigin();
      this.formatDestination();

      this.formatMessage();
      this.formatSubject();
    } else {
      let old = JSON.parse(localStorage.getItem('saved-schedules' + this.originId + this.destinationId));

      if (old !== null && old !== undefined) {
        old.items = [];
        this.schedules = old;
        this.formatOrigin();
        this.formatDestination();
      }
    }
    this.setupPagination();
  }

  formatOrigin() {
    this.nearbyOriginPorts = false;

    if (this.originType === 'port' || this.originType === 'share') {
      this.originPorts = this.schedules.originPorts;
    } else {
      for (let current = 0; current < this.originPorts.length; current++) {
        let item = this.originPorts[current];

        if (this.schedules.selectedOriginPorts.indexOf(item.port.id) > -1) {
          for (let index = 0; index < this.schedules.originPorts.length; index++) {
            if (item.port.id === this.schedules.originPorts[index].port.id) {
              item.selected = this.schedules.originPorts[index].selected;
              item.count = this.schedules.originPorts[index].count;
              item.iconUrl = this.schedules.originPorts[index].port.iconUrl;
            }
          }
        }
      }
    }
  }

  formatDestination() {
    this.nearbyDestinationPorts = false;

    if (this.destinationType === 'port' || this.destinationType === 'share') {
      this.destinationPorts = this.schedules.destinationPorts;
    } else {
      for (let current = 0; current < this.destinationPorts.length; current++) {
        let item = this.destinationPorts[current];

        if (this.schedules.selectedDestinationPorts.indexOf(item.port.id) >= 0) {
          for (let index = 0; index < this.schedules.destinationPorts.length; index++) {
            if (item.port.id === this.schedules.destinationPorts[index].port.id) {
              item.selected = this.schedules.destinationPorts[index].selected;
              item.count = this.schedules.destinationPorts[index].count;
              item.iconUrl = this.schedules.destinationPorts[index].port.iconUrl;
            }
          }
        }
      }
    }
  }

  formatMessage() {
    // ex. '153 Schedule Search Results. Origin: Shanghai; Destination: Yokohame; Departure: 16-10-5 to 16-10-12; Duration: 5 to 30 days; Carriers: Maersk, MSC, Evergreen'
    let carriers = '';
    try {

      if (this.schedules.selectedCarriers.length !== 0 && (this.schedules.selectedCarriers.length !== this.schedules.carriers.length)) {
        carriers = 'Carriers: ';
        for (let current = 0; current < this.schedules.carriers.length; current++) {
          carriers += this.schedules.carriers[current].selected ? this.schedules.carriers[current].name + ', ' : '';
        }
        carriers = carriers.slice(0, -2);
      }

      let origin = '';
      let destination = '';

      this.schedules.message =
        this.schedules.total.toString() +
        this.formatMessagePorts() +
        this.formatMessageDates() +
        carriers;
    } catch (ex) {
      this.schedules.message = '';
    }
  }

  formatMessagePorts(): String {
    let origin = this.originSearch === 'Origin' ? this.schedules.originPorts[0].port.name : this.originSearch;
    let destination = this.destinationSearch === 'Destination' ? this.schedules.destinationPorts[0].port.name : this.destinationSearch;
    return ' Schedule Search Results. Origin: ' + origin + '; Destination: ' + destination;
  }

  formatMessageDates(): String {
    let range = '';
    let duration = '';
    if (this.departureSet) {
      let beginning = encodeURIComponent(moment(this.departureDateGreater).format('YYYY-MM-DD'));
      let end = encodeURIComponent(moment(this.departureDateLess).format('YYYY-MM-DD'));
      range = '; Departure: ' + beginning + ' to ' + end + '; ';
    } else {
      let beginning = encodeURIComponent(moment(this.arrivalDateGreater).format('YYYY-MM-DD'));
      let end = encodeURIComponent(moment(this.arrivalDateLess).format('YYYY-MM-DD'));
      range = '; Arrival: ' + beginning + ' to ' + end + '; ';
    }

    if (this.minDuration !== 0 || this.maxDuration !== 0) {
      let beginning = this.minDuration.toString();
      let end = this.maxDuration.toString();
      duration = beginning + ' to ' + end + ' days; ';
    }
    return range + duration;
  }

  formatSubject() {
    try {
      let sharedBy = this.service.app.email === '' ? 'someone' : this.service.app.email;
      this.schedules.subject = this.schedules.total + ' Linescape Schedules Search Results shared by ' + sharedBy;
    } catch (ex) {
      this.schedules.subject = 'Linescape Schedule Search Results shared by someone';
    }
  }

  contact(schedule: any) {
    if (this.service.app.accountType === '') {
      this.service.app.showRegister();
    } else {
      this.contactSchedule = schedule;
      this.showContact = !this.showContact;
    }
  }

  closeContact() {
    this.showContact = false;
  }

  book(schedule: any) {

  }

  bookmark(schedule: any) {

  }

  viewDetails(item: any) {
    if (item.viewDetials = false) {
      try {
        // ga('send', 'event', 'Port Pair Results', 'Viewed Details');
      } catch (ex) {
      }
    }
    item.viewDetails = !item.viewDetails;
  }

  showDepartureRange = false;
  toggleDepartureRange() {
    this.showDepartureRange = !this.showDepartureRange;
    if (!this.showDepartureRange) {
      this.hideMaps();
      this.update();
    }
  }

  showArrivalRange = false;
  toggleArrivalRange() {
    this.showArrivalRange = !this.showArrivalRange;
    if (!this.showArrivalRange) {
      this.hideMaps();
      this.update();
    }
    // changed from (ngModelChange)=update() so it only updates when you close the departure range again
  }

  hideMaps() {
    this.mapsHiddenVar = true;
  }

  toggleSave() {
    this.showSave = !this.showSave;
  }

  closeSave() {
    this.showSave = false;
  }

  toggleShare() {
    this.showShare = !this.showShare;
  }

  closeShare() {
    this.showShare = false;
  }

  // searchesSearchIdDownloadGet
  destinationMarkerClicked(item: any) {
    this.selectDestinationPort(item);
  }

  originMarkerClicked(item: any) {
    this.selectOriginPort(item);
  }

  setSort(header: string) {
    this.sort = header;
    this.update();
  }

  toggleActions(schedule: any) {
    schedule.viewActions = !schedule.viewActions;
  }

  public sidebarActive = false;
  slideOutIn() {
    this.sidebarActive = !this.sidebarActive;
  }

  download() {
    if (this.service.app.accountType === '') {
      this.service.app.showRegister();
    } else {
      this.service.getDownload(this.schedules.searchId);
    }
  }

  toggleMaps(schedule: any) {
    if (localStorage.getItem('mapsHidden') === 'true' || this.mapsHiddenVar) {
      localStorage.setItem('mapsHidden', 'false');
      this.mapsHiddenVar = false;
    } else {
      localStorage.setItem('mapsHidden', 'true');
      this.mapsHiddenVar = true;
    }
  }

  expandOrigins() {
    this.showAllOriginPorts = true;
    this.service.resizeSidebar();
  }

  expandDestinations() {
    this.showAllDestinationPorts = true;
    this.service.resizeSidebar();
  }

  registerMessage() {
    this.service.app.showRegister();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/schedules/schedules.component.ts